import React, { Component } from "react";
import { Checkbox } from "antd";

export class CarStatusType extends Component {
  handleChangeCarStatus = (value) => {
    const { onChange } = this.props;
    this.props.onChange(value);
  };

  render() {
    const {
      value,
      disabled,
      typeOption,
      in_current_contract,
      in_current_journey_diary,
      status,
    } = this.props;
    return (
      <div className="car-status">
        <Checkbox
          disabled={
            disabled ||
            (typeOption === "create_new" ? true : false) ||
            status === 1 ||
            in_current_journey_diary ||
            (!in_current_contract && status === 0)
          }
          onChange={() => this.handleChangeCarStatus("DDD")}
          checked={value === "DDD"}
        >
          Đã điều động
        </Checkbox>
        <Checkbox
          disabled={
            disabled ||
            status === 2 ||
            in_current_journey_diary ||
            in_current_contract
          }
          onChange={() => this.handleChangeCarStatus("CDD")}
          checked={value === "CDD"}
        >
          Chờ điều động
        </Checkbox>
        <Checkbox
          disabled={disabled}
          onChange={() => this.handleChangeCarStatus("KTDD")}
          checked={value === "KTDD"}
        >
          Không thể điều động
        </Checkbox>
      </div>
    );
  }
}
